import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { DATA } from "../data/newsletterData";

function Newsletter() {
  const [data, setData] = useState();

  const path = useParams();

  useEffect(() => {
    setData(
      path &&
        DATA &&
        DATA.filter((d) => {
          return d.path === path.id;
        })
    );
  }, [path]);
  console.log(DATA);
  console.log(data);
  if (data === null || data === undefined || data.length === 0) {
    return (
      <NoData>
        <div>
          <img src="/image/not_found.svg" alt="" />
          <h1>
            No data found back to <a href="/">Home</a>.
          </h1>
        </div>
      </NoData>
    );
  }

  return (
    <Container>
      <div className="newsletter">
        <img
          src={`/image/banners/${data[0].image}`}
          alt=""
          className="newsletter_cover"
        />
        <h1 className="newsletter_h1">{data[0].title}</h1>
        {data[0].content &&
          React.Children.toArray(
            data[0].content.map((co) =>
              co.includes("$h1$") ? (
                <h1 className="newsletter_h1">{co.replace("$h1$", "")}</h1>
              ) : co.includes("$h2$") ? (
                <h2 className="newsletter_h2">{co.replace("$h2$", "")}</h2>
              ) : co.includes("$a$") ? (
                <a href={co.replace("$a$", "")} className="newsletter_a">
                  {co.replace("$a$", "")}
                </a>
              ) : co.includes("$code$") ? (
                <code className="newsletter_code">
                  {co.replace("$code$", "")}
                </code>
              ) : co.includes("$b$") ? (
                <p className="newsletter_p">
                  <strong>{co.replace("$b$", "")}</strong>
                </p>
              ) : co.includes("$bq$") ? (
                <blockquote>
                  <p>{co.replace("$bq$", "")}</p>
                </blockquote>
              ) : co.includes("$img$") ? (
                <div className="newsletter__flex">
                  <img
                    className="newsletter_img"
                    src={co.replace("$img$", "")}
                    alt=""
                  />
                </div>
              ) : (
                <p className="newsletter_p">{co}</p>
              )
            )
          )}
      </div>
    </Container>
  );
}

const Container = styled.main`
  display: flex;
  min-height: 100vh;
  .newsletter {
    margin: auto;
    text-align: left;
    width: min(100%, 800px);
    padding: 20px;
    .center_text {
      text-align: center;
    }
    &__flex {
      display: flex;
    }
    &_h1 {
      font-size: var(--big-text);
      margin: 15px 0;
    }
    &_h2 {
      font-size: var(--normal-text);
      margin: 15px 0;
    }
    &_p {
      font-size: var(--small-text);
      margin: 12px 0;
    }
    &_a {
      font-size: var(--small-text);
      margin: 12px 0;
      color: var(--link-color);
    }
    &_code {
      /* font-family: monospace; */
      background: var(--link-color);
      color: var(--bg);
      width: 100%;
      display: block;
      padding: 3px 10px;
    }
    &_img {
      max-width: 100%;
      margin: 10px auto;
    }

    blockquote p {
      padding: 15px;
      border-radius: 5px;
      font-size: var(--big-text);
      border-left: 3px solid var(--link-color);
      border-radius: 0;
    }

    blockquote p::before {
      content: '"';
    }

    blockquote p::after {
      content: '"';
    }

    &_cover {
      width: 100%;
    }
  }
`;

const NoData = styled.main`
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  img {
    width: min(100%, 400px);
  }
  a {
    color: var(--link-color);
    text-decoration: none;
  }
`;

export default Newsletter;
